
import KnotenClass from '../js/Knoten'

export const interactions = {
    // namespace: true,
    state: {
        vMoveSelectionMenu: false,
        vDivideStabMenu: false,
    },
    mutations: {
        setvMoveSelectionMenu(state, value){
            state.vMoveSelectionMenu = value
        },

        moveSelection(state){
            this.commit('setvMoveSelectionMenu', true)
        },


        setvDivideStabMenu(state, value){
            state.vDivideStabMenu = value
        },

        divideStab(state){
            this.commit('setvDivideStabMenu',true)
        },

        hideSelection(state){
            this.state.Selection.Stäbe.forEach(Stab=>{
                this.state.HiddenElements.push(Stab)
            })
            console.log(this.state.HiddenElements)
            this.dispatch('zeichne')
        },

        unhideAll(state){
            this.state.HiddenElements = []
            this.dispatch('zeichne')
        }

    },
    actions: {
        async moveSelection(context, {x,y,copies}){
            let Selection = this.state.Selection

            if (copies == 0){
                //Knoten
                Selection.Knoten.forEach(Knoten => {
                    // Check ob nicht auch ein Stab mit diesem Knoten selektiert ist
                    let vorhanden = false
                    Selection.Stäbe.forEach(cStab => {
                        if (cStab.StartKnoten === Knoten || cStab.EndKnoten === Knoten) vorhanden = true
                    })
                   if (!vorhanden) this.state.StatikSystem.editKnoten(Knoten, Knoten.x+x, Knoten.y+y, null)
                })
                //Stäbe
                Selection.Stäbe.forEach(Stab=>{
                    const {StartKnoten,EndKnoten} = Stab 
                    this.state.StatikSystem.editKnoten(StartKnoten,StartKnoten.x+x,StartKnoten.y+y,StartKnoten.Auflager)
                    this.state.StatikSystem.editKnoten(EndKnoten,EndKnoten.x+x,EndKnoten.y+y,EndKnoten.Auflager)                    
                })
            }

            for( let i=1; i <= copies; i++){
                
                //Knoten
                Selection.Knoten.forEach(Knoten => {
                    // Check ob nicht auch ein Stab mit diesem Knoten selektiert ist
                    let vorhanden = false
                    Selection.Stäbe.forEach(cStab => {
                        if (cStab.StartKnoten === Knoten || cStab.EndKnoten === Knoten) vorhanden = true
                    })
                    if (!vorhanden) this.state.StatikSystem.newKnoten(Knoten.x+x*i,Knoten.y+y*i,null)
                })

                //Stäbe
                Selection.Stäbe.forEach(Stab=>{
                    let cStartKnoten = this.state.StatikSystem.newKnoten(Stab.StartKnoten.x+x*i,Stab.StartKnoten.y+y*i,null)
                    let cEndKnoten = this.state.StatikSystem.newKnoten(Stab.EndKnoten.x+x*i,Stab.EndKnoten.y+y*i,null)
                    this.state.StatikSystem.newStab(cStartKnoten,cEndKnoten,Stab.Querschnitt,Stab.StartGelenk,Stab.Endgelenk,Stab.isFachwerkstab,Stab.Stabteilungen)
                })
            }
            this.dispatch('resetSolutions').then(this.dispatch('zeichne'))
        },

        async divideStab(context, {option,value}){
            let Selection = this.state.Selection
            if (option==1){
                Selection.Stäbe.forEach(Stab =>{
                    let deltaVec = Stab.vector.scale(1/value)
                    let urEndKnoten = Stab.EndKnoten
                    let Stabteilungen = parseInt(Stab.Stabteilungen/value+0.5)
                    for (let i=1; i<value; i++){
                        let curEndknoten = this.state.StatikSystem.newKnoten(Stab.StartKnoten.x+deltaVec.x,Stab.StartKnoten.y+deltaVec.y,null)
                        this.state.StatikSystem.editStab(Stab,Stab.StartKnoten,curEndknoten,Stab.Querschnitt,Stab.isFachwerkstab,Stab.StartGelenk,Stab.Endgelenk,Stabteilungen)
                        Stab = this.state.StatikSystem.newStab(curEndknoten,urEndKnoten,Stab.Querschnitt,Stab.StartGelenk,Stab.Endgelenk,Stab.isFachwerkstab,Stabteilungen)
                    }

                })
            }
            else {
                console.log("Stab bei Abstand teilen",value)
            }
            this.dispatch('resetSolutions').then(this.dispatch('zeichne'))
        }




    },
    getters: {
        vMoveSelectionMenu(state) { return state.vMoveSelectionMenu },
        vDivideStabMenu(state) { return state.vDivideStabMenu },
    }
}